import { useMutation } from "@tanstack/react-query";
import { generateCsvCertificate } from "api/services/lesson-service";
import { useAuthContext } from "hooks/useAuthContext";

interface GenerateCsvCertificateParams {
    userIds: string[];
    lessonId: string;
}

export const useGenerateCsvCertificate = () => {
    const { userState } = useAuthContext();

    const mutation = useMutation({
        mutationFn: async ({ userIds, lessonId }: GenerateCsvCertificateParams): Promise<{ blob: Blob; fileName: string }> => {
            const response = await generateCsvCertificate({
                workspaceId: userState.user.selectedWorkspace.workspaceId,
                lessonId,
                userIds,
            });

            if (!response.success || !response.data) {
                throw new Error(response.message ?? 'trainingReport.error');
            }

            return response.data;
        }
    });

    return {
        generateCsvCertificate: mutation.mutateAsync,
        generatingCsvCertificate: mutation.isPending,
    };
};
